// extracted by mini-css-extract-plugin
export default {"rain-effect":"RainEffect_rain-effect__RUM1C"};